var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{class:{
    default: _vm.theme === 'default',
    dark: _vm.theme === 'dark',
    light: _vm.theme === 'light',
    'no-margin': _vm.noMargin
  }},[_c('div',{staticClass:"container-xl"},[_c('h2',{attrs:{"data-aos":"fade-down"}},[_vm._v(_vm._s(_vm.title))]),(_vm.description)?_c('p',{attrs:{"data-aos":"fade-up"}},[_vm._v(_vm._s(_vm.description))]):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }